"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultQueryBuilderPlugins = void 0;
const RelatedEntitiesQueryBuilderPlugin_1 = require("./RelatedEntitiesQueryBuilderPlugin");
const SearchFieldsQueryBuilderPlugin_1 = require("./SearchFieldsQueryBuilderPlugin");
const TableColumnsQueryBuilderPlugin_1 = require("./TableColumnsQueryBuilderPlugin");
const WhereConditionQueryBuilderPlugin_1 = require("./WhereConditionQueryBuilderPlugin");
exports.defaultQueryBuilderPlugins = [
    WhereConditionQueryBuilderPlugin_1.WhereConditionQueryBuilderPlugin,
    RelatedEntitiesQueryBuilderPlugin_1.RelatedEntitiesQueryBuilderPlugin,
    TableColumnsQueryBuilderPlugin_1.TableColumnsQueryBuilderPlugin,
    SearchFieldsQueryBuilderPlugin_1.SearchFieldsQueryBuilderPlugin
];
//# sourceMappingURL=default.js.map